import React, { useEffect, useState } from "react";
import { Box, useTheme } from "@mui/material";
import Header from "components/Header";
import { useDispatch, useSelector } from "react-redux";
import MUIDataTable from "mui-datatables";
import moment from "moment";
import "moment/locale/id";
import AddNotifikasiModal from "components/Modals/AddNotifikasiModal";
import FloatingAlert from "components/FloatingAlert";
import { setMessage, setStatus } from "state";
import { fetchListDivisi } from "state/divisiActions";
moment.locale("id");

const Divisi = () => {
  const theme = useTheme();
  const dispatch = useDispatch();
  const [openAdd, setOpenAdd] = useState(false);
  const [rowsPerPage, setRowsPerPage] = useState(30);

  const { status, message } = useSelector((state) => state.global);
  const { list_divisi } = useSelector((state) => state.divisi);

  useEffect(() => {
    dispatch(fetchListDivisi());
  }, []);

  const handleCloseSnackbar = () => {
    dispatch(setStatus("default"));
    dispatch(setMessage(""));
    dispatch(fetchListDivisi());
  };

  const handleSubmitNotifikasi = (value) => {
    const reqData = {
      title: value.judul,
      body: value.isi,
    };

    dispatch(fetchListDivisi(reqData));
  };
  const columnsDivisi = [
    {
      name: "kode_divisi",
      label: "Kode Divisi",
      options: {
        filter: true,
        sort: false,
      },
    },
    {
      name: "nama_divisi",
      label: "Nama Divisi",
      options: {
        filter: true,
        sort: false,
      },
    },
    // {
    //   name: "aksi",
    //   label: "Aksi",
    //   options: {
    //     filter: false,
    //     sort: false,
    //     customBodyRender: (value, tableMeta) => {
    //       const id = tableMeta.rowData[0];
    //       return (
    //         <>
    //           <IconButton color="info" onClick={() => handleEdit(id)}>
    //             <Edit />
    //           </IconButton>
    //           <IconButton color="error" onClick={() => handleDelete(id)}>
    //             <Delete />
    //           </IconButton>
    //         </>
    //       );
    //     },
    //   },
    // },
  ];

  const options = {
    selectableRows: "none",
    filterType: "dropdown",
    fixedHeader: false,
    fixedSelectColumn: false,
    responsive: "standard",
    rowsPerPageOptions: [30, 60, list_divisi.length],
    rowsPerPage: rowsPerPage,
    onChangeRowsPerPage: (numberOfRows) => setRowsPerPage(numberOfRows),
  };

  return (
    <Box m="1.5rem 2.5rem">
      {/* <FlexBetween> */}
      <Header title="Divisi" subtitle="Daftar divisi di perusahaan." />

      {/* <Box>
          <Button
            sx={{
              backgroundColor: theme.palette.secondary.light,
              color: theme.palette.background.alt,
              fontSize: "14px",
              fontWeight: "bold",
              padding: "10px 20px",
              "&:hover": {
                backgroundColor: theme.palette.secondary.light, // Tetap sama dengan warna awal
              },
            }}
            onClick={() => setOpenAdd(true)}
          >
            <Groups2Outlined sx={{ mr: "10px" }} />
            Tambah Divisi
          </Button>
        </Box>
      </FlexBetween> */}
      <Box
        mt="40px"
        height="75vh"
        sx={{
          "& .MuiDataGrid-root": {
            border: "none",
          },
          "& .MuiDataGrid-cell": {
            borderBottom: "none",
          },
          "& .MuiDataGrid-columnHeaders": {
            backgroundColor: theme.palette.background.alt,
            color: theme.palette.secondary[100],
            borderBottom: "none",
          },
          "& .MuiDataGrid-virtualScroller": {
            backgroundColor: theme.palette.primary.light,
          },
          "& .MuiDataGrid-footerContainer": {
            backgroundColor: theme.palette.background.alt,
            color: theme.palette.secondary[100],
            borderTop: "none",
          },
          "& .MuiDataGrid-toolbarContainer .MuiButton-text": {
            color: `${theme.palette.secondary[200]} !important`,
          },
        }}
      >
        <MUIDataTable
          title={""}
          data={list_divisi}
          columns={columnsDivisi}
          options={options}
        />
        <AddNotifikasiModal
          open={openAdd}
          onClose={() => setOpenAdd(false)}
          onSubmit={(value) => handleSubmitNotifikasi(value)}
        />
        <FloatingAlert
          open={message.length > 0}
          onClose={handleCloseSnackbar}
          message={message}
          severity={status === "failed" ? "error" : status}
        />
      </Box>
    </Box>
  );
};

export default Divisi;
